module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14YvPAh/tc-custom/9781035807161.jpg?1718183630873",
      "alt": "This image is the cover for the book The Loo Lid Larceny"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Loo Lid Larceny\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Disaster has hit the home suburb of Marnie and Tiana. Someone started stealing toilet lids, and often the whole seat. It started in public places then it started in private homes! Why would anyone contemplate such a vile act? Tempers, anxieties and frustration rise as more and more lids disappear. People go to futile extremes to protect their toilets. What is behind the wave of odious thefts? Is it Cec Pitt, TV presenters of The Collectors and Gatherers Show and, antique and preloved goods dealer involved? Marnie and Tiana are determined to get to the bottom of the mystery and save the nation from an evil, embarrassing scam.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alan Horsfield\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Alan Horsfield is an established children’s writer. He is a past president of the NSW Children’s Book Council (CBC) and a former judge for the NSW Premiers (Children’s) Book Awards. His books have been included in Australian State Premiers’ school reading lists. Industry reviews have been positive. First published in 1996, he presently has over 35 works of fiction for younger readers and the YA market. He intends to stretch the imagination of readers. He has written/co-written over 140 educational texts and worked with UNSW educational assessment. Alan is a full member of SCBWI.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0